import { useState } from "react";
import { useHistory } from "react-router-dom";
import { useApiCall } from "@/_common/hooks/actions/common/appApiCallHook";
import { SAGA_ACTIONS, URLS } from "@/_config";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Loader2 } from "lucide-react";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const callApi = useApiCall();
  const history = useHistory();

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setError("");

    if (!email || !password) {
      setError("Email and password are required.");
      return;
    }

    setLoading(true);
    callApi(
      SAGA_ACTIONS.ADMIN.AUTH.LOGIN,
      { email, password },
      (_msg: string, resp: any) => {
        setLoading(false);
        if (resp?.requires_2fa) {
          history.push(URLS.AUTH.VERIFY_OTP, { email: resp.email });
        } else {
          history.push(URLS.DASHBOARD.HOME);
        }
      },
      (msg: string) => {
        setLoading(false);
        setError(msg || "Invalid credentials. Please try again.");
      }
    );
  };

  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-4">
      <div className="w-full max-w-sm">
        <div className="flex flex-col items-center mb-8">
          <div className="w-12 h-12 rounded-xl bg-primary flex items-center justify-center text-primary-foreground font-bold text-2xl mb-4">
            D
          </div>
          <h1 className="text-2xl font-bold text-foreground tracking-tight">
            Dr.Job <span className="text-primary">Admin</span>
          </h1>
          <p className="text-muted-foreground text-sm mt-1">Sign in to your admin account</p>
        </div>

        <div className="bg-card border border-border rounded-xl p-6 shadow-sm">
          <form onSubmit={handleSubmit} className="flex flex-col gap-4">
            <div>
              <label className="text-sm font-medium text-foreground mb-1.5 block">Email</label>
              <Input
                type="email"
                placeholder="admin@drjobpro.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                autoComplete="email"
                autoFocus
              />
            </div>
            <div>
              <label className="text-sm font-medium text-foreground mb-1.5 block">Password</label>
              <Input
                type="password"
                placeholder="••••••••"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                autoComplete="current-password"
              />
            </div>

            {error && (
              <p className="text-sm text-destructive bg-destructive/10 border border-destructive/20 rounded-md px-3 py-2">
                {error}
              </p>
            )}

            <Button type="submit" className="w-full mt-1" disabled={loading}>
              {loading ? <><Loader2 className="w-4 h-4 mr-2 animate-spin" />Signing in...</> : "Sign In"}
            </Button>
          </form>
        </div>

        <p className="text-center text-xs text-muted-foreground mt-6">
          DrJobs Admin Panel &copy; {new Date().getFullYear()}
        </p>
      </div>
    </div>
  );
}
